import styled from 'styled-components';
import { darken } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import ButtonBase from '@material-ui/core/ButtonBase';

import {
    DatePicker,
    DateTimePicker,
    KeyboardDatePicker,
    KeyboardTimePicker,
} from '@material-ui/pickers';

export const StyledFormControl = styled(FormControl)`
    ${() => `
    padding: 0;
    margin: 5px 0;
    width: 100%;

    z-index: 0;
 `}
`;

export const StyledLabel = styled.label`
    ${({ theme, $color }) => `
    font-family: ${theme.typography.fontFamily};
    font-size: 12px;
    color: ${$color ? theme.palette.common[$color] : theme.palette.common.gray2};
    padding-left: 20px;
    margin-bottom: 5px;
    `}
`;

export const StyledInput = styled(TextField)`
    ${({ theme, $inputHeight, error }) => `
    border: 1px solid ${theme.palette.common.blue};
    border-radius: 25px;
    background-color: ${theme.palette.common.white};
    width: 100%;
    margin: 0;
    height: ${$inputHeight ? $inputHeight : '32px'};

    & fieldset {
        border-radius: 25px;
        border-color: ${error ? theme.palette.common.red : theme.palette.common.gray7};
      },

    & input {
        height: ${$inputHeight ? $inputHeight : '32px'};
        box-sizing: border-box;
    }
    `}
`;

export const StyledOutlinedInput = styled(OutlinedInput)`
    ${({ theme, $inputHeight, error, $backgroundColor, $disabledColor, disabled }) => `
    border-radius: 25px;
    background-color: ${
        disabled
            ? theme.palette.common.gray6
            : $backgroundColor
            ? theme.palette.common[$backgroundColor]
            : theme.palette.common.white
    };
    width: 100%;
    margin: 0;
    height: ${$inputHeight ? $inputHeight : '32px'};

    padding-top: 5px;
    padding-bottom: 5px;

    & fieldset {
        border-radius: 25px;
        border-color: ${error ? theme.palette.common.red : theme.palette.common.gray7};
    },

    .MuiOutlinedInput-inputMarginDense {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .MuiInputBase-input.Mui-disabled {
        color: ${
            $disabledColor ? theme.palette.common[$disabledColor] : theme.palette.common.gray4
        } !important;
    }

    
`}
`;

export const StyledFormHelperText = styled(FormHelperText)`
    ${() => `
      padding-left: 20px;
      margin: 0;
      `}
`;

export const StyledCheckbox = styled(Checkbox)`
    ${() => `
    padding: 0;
    `}
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
    ${({ theme }) => `
    color:${theme.palette.common.black};
    margin: 0;
    `}
`;

export const StyledFormGroup = styled(FormGroup)`
    ${() => `
    
    `}
`;

export const StyledDatePicker = styled(DatePicker)`
    ${() => `
    
    `}
`;

export const StyledDateTimePicker = styled(DateTimePicker)`
    ${() => `

    `}
`;

export const StyledKeyboardDatePicker = styled(KeyboardDatePicker)`
    ${({ theme, error }) => `
        width: 100%;
        & fieldset {
            // border-color: ${error ? theme.palette.common.red : theme.palette.common.gray7};
            border-color: ${theme.palette.common.gray7};
        }
    `}
`;

export const StyledKeyboardTimePicker = styled(KeyboardTimePicker)`
    ${() => `
        width: 100%;
    `}
`;

export const useStylesSelect = makeStyles((theme) => ({
    root: (props) => ({
        borderRadius: '25px',
        padding: '0 15px 0 10px',
        backgroundColor: `${
            props.disabled ? theme.palette.common.gray6 : theme.palette.common.white
        }`,
        width: '100%',
        height: props.$inputHeight ? props.$inputHeight : '32px',

        '& .MuiSelect-select': {
            paddingLeft: '20px',
        },
        '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
        },

        '& fieldset': {
            borderColor: `${theme.palette.common.gray7}`,
        },
    }),
}));

export const useStylesRadio = makeStyles(() => ({
    root: () => ({
        paddingTop: 0,
        paddingBottom: 0,
    }),
}));

export const useStylesRadioCardRadio = makeStyles((theme) => ({
    root: {
        padding: 0,
        marginTop: '1px',
        color: theme.palette.common.primaryBlue,
        '&.Mui-checked': {
            color: theme.palette.common.primaryBlue,
        },
    },
}));

export const StyledRadioCard = styled.div`
    ${({ theme, active }) => `
    width: 100%;
    padding: 15px;
    border-radius: 16px;
    border: 1px solid ${active ? theme.palette.common.primaryBlue : theme.palette.common.gray4};
    display: flex;
    align-items: flex-start;
    column-gap: 10px;
    cursor: pointer;
    `}
`;

export const StyledRadioCardContent = styled.div`
    ${() => `
    
    `}
`;

export const StyledSelectProviderButton = styled(ButtonBase)`
    ${({ theme, $borderColor, $backgroundColor }) => `
        width: 100%;
        height: 48px;
        overflow: hidden;

        border-radius: 8px;
        border: 1px solid ${
            $borderColor ? theme.palette.common[$borderColor] : theme.palette.common.gray5
        };
        background-color: ${
            $backgroundColor ? theme.palette.common[$backgroundColor] : theme.palette.common.white
        };

        &:hover {
            background-color: ${
                $backgroundColor
                    ? darken(theme.palette.common[$backgroundColor], 0.1)
                    : darken(theme.palette.common.white, 0.1)
            };
              }
      
        
    `}
`;
